import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Routes } from '@angular/router';
import { CategoriesService } from '../shared/services/categories.service';
import { CategoryCollection } from '../shared/models/categories/category-collection';
import { Page } from '../shared/models/pages/page';
import { PagesService } from '../shared/services/pages.service';
import { PostsService } from '../shared/services/posts.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Post } from '../shared/models/posts/post';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  public categories: any = [];
  public page: Page = null;
  public parent: number = null;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _route: Router,
    private _categoriesService: CategoriesService,
    private _pagesService: PagesService,
    private _postsService: PostsService,
    private _sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this._activatedRoute.params.subscribe(
      params => {    
        this._getCategories(params['id']);
      }
    );    

    this._pagesService.getData({slug: 'categories'}).subscribe(
      response => this.page = new Page(response),
      error => {
        console.log(error);
        this.page = new Page({});
      }
    );
  }

  public get content(): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(this.page.content.rendered);
  }

  public follow(category) {
    switch (category.name) {
      case 'czujki' : 
        this._getCategories(category.id, '/czujki');
        break;
      case 'domusie' : 
        this._getCategories(category.id, '/domusie');
        break;        
      case 'niebyleczo' : 
        this._getCategories(category.id, '/niebyleczo');
        break;                
      default :
        this._getCategories(category.id);
    }
    
    // this._route.navigate(['/categories', id]);  
  }

  public backToMain() {
    if (this.parent !== 0) {
      this._getCategories(0);
    }
  }


  private _getCategories(parent: number = 0, redirect = '') {    
    this._categoriesService.getCategories(
      {
        per_page: 100,
        parent: parent
      }
    ).subscribe(
      response => {        
        let categories = new CategoryCollection(response).itemsOrdered();        
        if (categories.length) {
          this.categories = categories;
          this.parent = parent;
        } else if (parent !== 0) {          
          this._getPosts(parent, redirect);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  private _getPosts(category: number, redirect = '') {
    this._postsService.getPosts(
      {
        categories: category,
        per_page: 1,
        "filter[orderby]": "date",
        "order": "asc"
      }
    ).subscribe(
      response => {  
        let post = new Post(response);      
        if (post.id) {
          if (redirect !== '') {
            this._route.navigate([redirect, post.id]);
          } else {
            this._route.navigate(['/task', post.id]);
          }
        } else {          
          console.warn('Uwaga! Kategoria nie ma zadań.');
          // w przypadku gdy wchodzi sie bezposrenio w rotuing /categories/1
          if (this.parent === null) {
            this._getCategories(0);
          }
        }
      }, 
      error => {
        console.log(error);
      }
    );
  }
}
